import { getFooterLinks } from "~/providers/links";

import "./style.less";

// tenka paticka - copyright a pravni odkazy, ostatni odkazy jsou v hamburger menu
export default function Footer() {
	const year = new Date().getFullYear();

	return <footer className="footer">
		<span className="footer__copyright">DO IT FOR YOURSELF © {year}</span>
		{ getFooterLinks().map(item => <a className="footer__link" href={item.route} key={item.route} target="_blank" rel="noopener noreferrer">
			{item.title}
		</a>) }
	</footer>;
}
